declare const RASA_DASHBOARD_HOME_PAGE: string

export const sendToLogin = () => {
  window.location.href = `${RASA_DASHBOARD_HOME_PAGE}/login${window.location.search}`
}
